import { retrieveCookie } from 'src/utils/browser/cookies';
import type { UserData } from '../types';
import { getStoreId } from 'src/utils/BasePathTools';

export const COOKIES = {
	ITXSESSIONID: 'ITXSESSIONID',
	USER_TOKEN: 'gut',
	USER_TYPE: 'user_type',
	USER_TYPE_OLD: 'userType',
	USER_ID_COOKIE_NAME: 'user_id',
	UAITXID: 'UAITXID'
} as const;

const LS_SEPARATOR = '!xticcsep*!';

function retrieveLocalStorage<T = unknown>(key: string): T | null {
	try {
		const raw = window.localStorage.getItem(key);
		if (!raw) return null;
		const parts = raw.split(LS_SEPARATOR);
		if (parts[1] && Date.now() > Number(parts[1])) {
			window.localStorage.removeItem(key);
			return null;
		}
		return JSON.parse(parts.slice(3).join('')) as T;
	} catch {
		return null;
	}
}

function getStoredUserSession(): { userData?: { userId?: string } } | null {
	const key = `currentUserSession@${getStoreId()?.toString()}`;
	return retrieveLocalStorage(key);
}

function getUserKind(): string {
	const userType =
		retrieveCookie(COOKIES.USER_TYPE) ||
		retrieveCookie(`${COOKIES.USER_TYPE}@${getStoreId()?.toString()}`) ||
		retrieveCookie(COOKIES.USER_TYPE_OLD);
	return userType || 'guest';
}

function getUserId(): string | null {
	const userSession = getStoredUserSession();
	return userSession?.userData?.userId || retrieveCookie(COOKIES.USER_ID_COOKIE_NAME) || null;
}

export interface IIdentityProvider {
	getSessionId(): string | undefined;
	getUserData(): UserData;
}

class NonEmbeddedIdentityProvider implements IIdentityProvider {
	getSessionId(): string | undefined {
		return retrieveCookie(COOKIES.ITXSESSIONID);
	}

	getUserData(): UserData {
		return {
			token: retrieveCookie(COOKIES.USER_TOKEN),
			kind: getUserKind(),
			userId: getUserId(),
		};
	}
}

export function getIdentityProvider(): IIdentityProvider {
	return new NonEmbeddedIdentityProvider();
}
